<template>
  <a-table
    bordered
    :showHeader="false"
    class="footerTable"
    :columns="footerTableColumns"
    :data-source="sumInfoList"
    :pagination="false"
  >
<!--    <template #index>-->
<!--      <span>合计</span>-->
<!--    </template>-->
<!--    <template #sumDemandQuantity="text">-->
<!--      <span>{{ text }}</span>-->
<!--    </template>-->
    <template v-for="item in dateFiledList" :slot="item.dataIndex" slot-scope="text, record">
      <div :key="'summary-val-'+item.dataIndex">
        {{ item.setVal || record[item.dataIndex] }}
      </div>
    </template>
  </a-table>
</template>

<script>
import { fixedTable } from "lsmy-libs";
export default {
  name: 'StickFixedSummary',
  mixins: [ fixedTable ],
  props: {
    dateFiledList: {
      type: Array,
      default: () => []
    },
    footerTableColumns: {
      type: Array,
      default: () => []
    },
    columns: {
      type: Array,
      default: () => []
    },
    summaryApi: {
      type: Function,
      default: () => () => {}
    }
  },
  data() {
    return {
      sumInfoList: [{}] // 合计
    }
  },
  methods: {
    // 通过API汇总查询
    summaryFromApi(params, summaryApi) {
      this.sumInfoList = [{}]
      summaryApi(params).then(res => {
        this.sumInfoList = res?.data ? [res.data] : [{}]
      })
    },
    // 合并表格设置同步滚动
    setScroll (parentRef) {
      // 同步表与footer滚动
      const dom = parentRef.$el.querySelectorAll('.ant-table-body')[0]
      dom.addEventListener('scroll', () => {
        parentRef.$el.querySelectorAll('.ant-table-body')[1].scrollLeft = dom.scrollLeft
      }, true)
    },
    // 初始化
    initSet(parentRef) {
      this.$nextTick(() => {
        this.setScroll(parentRef);
        this.stickyFixedColumns(this.columns)
        this.stickyFixedColumns(this.footerTableColumns)
      })
    }
  }
}
</script>

<style lang="less" scoped></style>
